'use strict'

module.exports = {
  NODE_ENV: '"eu"',
  APP_BASEURL: '"https://hermes-eu.protopia.co/"',
  API_BASEURL: '"https://api-eu.protopia.co/"',
  APP_REDIRECT_URL: '"https://protopia.co/maintenance"',
  AUTH0_DOMAIN: '"protopia.eu.auth0.com"',
  AUTH0_CLIENT: '"uuE0EkVY3kkUg8VzhZkpCzrzbJWjPxfU"',
  AUTH0_CALLBACK: '"https://hermes-eu.protopia.co/callback"',
  NLP_API_KEY: '"AIzaSyD76cXYBDRRolN7agqVkB1gu9EQekYranw"',
  LOGO_URL: '"https://storage.googleapis.com/protopia/logos/logo_protopia_xs.png"',
  LINKEDIN_CLIENT_ID: '"86bm0xpurfqdqb"',
  LINKEDIN_CLIENT_SECRET: '"i0MwVy2mRbdJk5E7"',
  LINKEDIN_REDIRECT_URI: '"https://hermes.protopia.co/thank-you"',
  LINKEDIN_STATE_KEY: '"PROTOPIA"',
  DEFAULT_EMAIL: '"team@protopia.co"',
  RANDOM_INTEREST_COUNT: 15,
  ADDITIONAL_PARAM_FRIENDLY_COUNT: 12,
  APP_REDIRECT_TIME: 10000,
  CAPTCHA_SITEKEY: '6Lcgl3wsAAAAAHsITIy93KrgFXJ2A4DidV8d4mts',
  VUE_APP_PROCESS_DASHBOARD_URL: '"https://hermes-eu.protopia.co/process-dashboard"',

  // Public base of the recruiting wizard.
  RECRUITING_BASEURL: '"https://opportunities.protopia.co"'
}



//////////////////
// WEBPACK FOOTER
// ./config/eu.env.js
// module id = gK33
// module chunks = 1